import axios from "axios"
import { Link, Redirect } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { API } from "../../api"
import SearchRecomandation from "./searchRecomandation"


function createCard(data) {
  return <SearchRecomandation name={data.name} id={data.pr_id} />
}

export default function PcSearch() {
  const [recomandation, setRecomandation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState("")
  const [suggest, setSuggest] = useState([])
  const [redirect, setRedirect] = useState(false);

  const handleChange = e => {
    const query = e.target.value
      .trim()
      .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
  
    setValue(query)
    if (value.length > 1) {
      setLoading(true)
      axios.get(`${API}products/search/${value}`).then(res => {
        if (res.status === 200) {
          if (res.data.data.length === 0) {
            setSuggest([
              {
                name: "Try to search another Items..😟 ",
                pr_id: "",
              },
            ])
          } else {
            setSuggest(res.data.data)
          }
        }
      })
    }
    if (value) {
      setSuggest([])
    }
  }
  useEffect(() => {
    if (loading) {
      setSuggest([
        {
          name: "Loading...",
          pr_id: "",
        },
      ])
    }
  }, [loading])

  const handleEnter = e => {
    if (e.key === "Enter") {
      setRedirect(true);
    }
  }

  const handleFocus = () => {
    setRecomandation(true)
  }
  const closeRecomandation = () => {
    setRecomandation(false)
  }

  return (
    <div className="pc-search">
      <div className="input-box">
        <ion-icon name="search"></ion-icon>
        <input
          type="text"
          placeholder="Search Items..."
          onChange={handleChange}
          onKeyDown={handleEnter}
          onFocus={handleFocus}
        />
      </div>
      {recomandation && (
        <>
          <div className="search-recomandation-box">
            {suggest.length !== 0 && suggest.map(createCard)}
          </div>
          <div
            className="close-search-recomandation"
            onClick={closeRecomandation}
          ></div>
        </>
      )}
      {redirect && (<Redirect to="/search-results/${value}" />)}
    </div>
  )
}
